var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Team_Active",
    transform: "translate(-14 -109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Team_Active-2",
    "data-name": "Team_Active",
    transform: "translate(15 110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142904",
    "data-name": "Path 142904",
    d: "M44.525,2.308a2.308,2.308,0,1,0-2.308,2.308A2.311,2.311,0,0,0,44.525,2.308Z",
    transform: "translate(-38.266 0)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142905",
    "data-name": "Path 142905",
    d: "M7.9,116.532v-.71a3.951,3.951,0,0,0-7.9,0v.71a.622.622,0,0,0,.622.622H7.279A.622.622,0,0,0,7.9,116.532Z",
    transform: "translate(0 -107.255)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142906",
    "data-name": "Path 142906",
    d: "M365.859,2.308a2.308,2.308,0,1,0-2.308,2.308A2.311,2.311,0,0,0,365.859,2.308Z",
    transform: "translate(-346.284 0)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142907",
    "data-name": "Path 142907",
    d: "M325.284,111.4a3.955,3.955,0,0,0-3.951,3.951v.71a.622.622,0,0,0,.622.622h6.658a.622.622,0,0,0,.622-.622v-.71A3.955,3.955,0,0,0,325.284,111.4Z",
    transform: "translate(-308.018 -106.784)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142908",
    "data-name": "Path 142908",
    d: "M65.517,269c0-.044,0-.088,0-.133H64.275a7.936,7.936,0,0,0,3.242,6.538,5.205,5.205,0,0,1,.663-1.056A6.691,6.691,0,0,1,65.517,269Z",
    transform: "translate(-61.61 -257.725)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142909",
    "data-name": "Path 142909",
    d: "M166.565,82.368a6.769,6.769,0,0,1,5.486,0,5.236,5.236,0,0,1,1-.89,8.022,8.022,0,0,0-7.5,0A5.238,5.238,0,0,1,166.565,82.368Z",
    transform: "translate(-158.699 -77.21)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142910",
    "data-name": "Path 142910",
    d: "M356.111,268.867a6.7,6.7,0,0,1-2.662,5.482,5.208,5.208,0,0,1,.663,1.056,7.936,7.936,0,0,0,3.242-6.538Z",
    transform: "translate(-338.802 -257.725)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142911",
    "data-name": "Path 142911",
    d: "M205.192,275.441a2.308,2.308,0,1,0-2.308,2.308A2.311,2.311,0,0,0,205.192,275.441Z",
    transform: "translate(-192.275 -261.815)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142912",
    "data-name": "Path 142912",
    d: "M164.617,384.533a3.955,3.955,0,0,0-3.951,3.951v.71a.622.622,0,0,0,.622.622h6.658a.622.622,0,0,0,.622-.622v-.71A3.955,3.955,0,0,0,164.617,384.533Z",
    transform: "translate(-154.009 -368.598)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14860",
    "data-name": "Rectangle 14860",
    width: 23,
    height: 23,
    transform: "translate(14 109)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamActive);
export default __webpack_public_path__ + "static/media/team_active.331979c1.svg";
export { ForwardRef as ReactComponent };